/* Copyright (c) 2020 Environmental Systems Research Institute, Inc.
 * Apache-2.0 */
var ARCGIS_ONLINE_GEOENRICHMENTSERVER_URL = "https://geoenrich.arcgis.com/arcgis/rest/services/World/geoenrichmentserver";
export var ARCGIS_ONLINE_GEOENRICHMENT_URL = ARCGIS_ONLINE_GEOENRICHMENTSERVER_URL + "/Geoenrichment";
export var ARCGIS_ONLINE_STANDARD_GEOGRAPHY_QUERY_URL = ARCGIS_ONLINE_GEOENRICHMENTSERVER_URL + "/StandardGeographyQuery";
//# sourceMappingURL=helpers.js.map